import { Link } from "react-router-dom";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Responsive from "../Pages/Responsive";

const HeaderResponsiveComponent = ({ handlescroll }) => {
  const handleMenu = () => {
    // let conw = document.querySelector("summary-title-header").classList.toggle("hidden");
    let temp = document.querySelector("nav").classList.toggle("hidden");

    console.log(temp);
    // console.log(conw);
  };
  const closeDropFunction = (id) => {
    document.getElementById(id).style.display = "none";
    document.getElementById(id).style.opacity = 0;
  };
  const openDropFunction = (id) => {
    document.getElementById(id).style.display = "block";
    document.getElementById(id).style.opacity = 1;
  };
  const mobileDropdown = () => {
    openDropFunction("mobileDrop");
    document.getElementById("header").style.overflowY = "visible";
    setTimeout(() => {
      closeDropFunction("mobileDrop");
      document.getElementById("header").style.overflowY = "scroll";
    }, 3000);
  };
  return (
    <header id="header" className="bg-[#F21E26] pt-4 pb-4 block z-40">
      <div className="max-w-[70rem] mx-auto lg:flex lg:justify-between items-center px-6">
        <a href="/" className="hidden lg:block">
          <img
            src="/TCS.svg"
            alt=""
            className="md:w-[9rem] sm:w-[7rem] w-[6rem]"
          />
        </a>
        <div className="flex justify-between z-40 mobileMain overflow-y-visible">
          <a href="/" className="lg:hidden md:block">
            <img src="/TCS.svg" alt="" className="sm:w-[7rem] w-[5rem]" />
          </a>

          <div className="flex relative">
            <div
              className={`lg:hidden sm:flex sm:justify-end nav cursor-pointer text-[white] pt-[.7rem] mr-[1rem]`}
              onClick={mobileDropdown}
            >
              Pakistan
              <KeyboardArrowDownIcon />
              <div id="mobileDrop" className="absolute dropdown">
                <div
                  className="absolute w-10 h-6 bg-white top-[.1rem] left-10"
                  style={{ clipPath: "polygon(50% 0%, 0px 85%, 100% 85%)" }}
                ></div>

                <div className="w-[17rem] absolute"></div>
                <div className="shadow-md bg-white text-[#373737] text-xs w-[6.8rem] rounded-b-sm mt-1 relative z-10 top-[0.25rem] ">
                  <ul className="grid p-1">
                    <a
                      className="py-[0.3rem] px-3 hover:bg-[#e1e1e1]"
                      href="https://uae.tcsexpress.com/"
                      target="_blank"
                    >
                      The UAE
                    </a>

                    <a
                      className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] z-100"
                      href="https://tcsexpress.co.uk/"
                      target="_blank"
                    >
                      {/* {" "} */}
                      The UK
                    </a>
                    <a
                      className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] z-100"
                      href="http://tranzumtrade.com/"
                      target="_blank"
                    >
                      {/* {" "} */}
                      Central Asia
                    </a>
                  </ul>
                </div>
              </div>
            </div>
            <button
              type="primary"
              className="lg:hidden text-2xl h-[1rem] md:flex lg:justify-right md:justify-end right-[1rem] mt-[.4rem] text-[white]"
              onClick={handleMenu}
            >
              <i className="fa-solid fa-bars"></i>
            </button>
          </div>
        </div>

        <div className="text-white text-sm font-light flex-col flex justify-center mobileMenu">
          <div
            className={`sentiment hidden lg:flex  flex mb-2 self-end gap-6" sm:pt-2`}
          >
            <a target="_blank" href="https://sentimentsexpress.com/">
              <img
                src="/brands/sentiments.svg"
                className="w-[4rem] mr-[2.3rem]"
              />
            </a>
            <a target="_blank" href="https://www.studiobytcs.com/">
              <img
                src="/brands/studio.svg"
                className="w-[3.5rem] mt-[.2rem] mr-[4rem]"
              />
            </a>
            <div
              className={` nav cursor-pointer`}
              onMouseEnter={() => openDropFunction("countryDrop")}
              onMouseLeave={() => closeDropFunction("countryDrop")}
              // onClick={() => closeDropFunction('countryDrop')}
            >
              Pakistan
              <KeyboardArrowDownIcon />
              <div id="countryDrop" className="absolute dropdown">
                <div
                  className="absolute w-10 h-6 bg-white top-[.1rem] left-10"
                  style={{ clipPath: "polygon(50% 0%, 0px 85%, 100% 85%)" }}
                ></div>
                <div className="w-[17rem] h-12 absolute none"></div>
                <div className="py-3 shadow-md bg-white text-[#373737] text-xs w-[6.1rem] rounded-b-sm mt-1 relative z-10 top-[0.25rem]">
                  <ul className="grid">
                    <a
                      className="py-[0.3rem] px-3  hover:bg-[#e1e1e1]"
                      href="https://uae.tcsexpress.com"
                      target="_blank"
                    >
                      The UAE
                    </a>

                    <a
                      className="py-[0.3rem] px-3  hover:bg-[#e1e1e1]"
                      href="https://tcsexpress.co.uk"
                      target="_blank"
                    >
                      {/* {" "} */}
                      The UK
                    </a>
                    <a
                      className="py-[0.3rem] px-3  hover:bg-[#e1e1e1]"
                      href="http://tranzumtrade.com/"
                      target="_blank"
                    >
                      {/* {" "} */}
                      Central Asia
                    </a>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <nav className="hidden lg:flex relative">
            <Responsive
              className="bg-[red] w-[100vh]"
              handleMenu={handleMenu}
            />
            <ul className="hidden md:hidden lg:flex gap-3 items-center  md:mx-auto md:justify-center">
              <div className="backdropdown absolute left-0 right-0 bottom-0 top-[20rem] z-10 opacity-50"></div>
              <li
                onMouseEnter={() => openDropFunction("aboutDrop")}
                onMouseLeave={() => closeDropFunction("aboutDrop")}
                // onClick={() => closeDropFunction('aboutDrop')}
                className="nav cursor-pointer"
              >
                <Link to="/about" className="py-[0.3rem] px-0 block ">
                  About Us
                  <i className="fa-solid fa-angle-down pl-2"></i>
                </Link>
                <div id="aboutDrop" className="absolute dropdown">
                  <div
                    className="absolute w-10 h-6 bg-white top-[0.5rem] left-10"
                    style={{ clipPath: "polygon(50% 0%, 0px 85%, 100% 85%)" }}
                  ></div>
                  <div className="w-[17rem] h-12 absolute none"></div>
                  <div className="py-2 shadow-md bg-white text-[#373737] text-xs w-[9.9rem] rounded-b-sm mt-1 relative z-10 top-[1.05rem]">
                    <ul className="">
                      <li onClick={() => closeDropFunction("aboutDrop")}>
                        <Link
                          to="/about/mission"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Mission & Core Values
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("aboutDrop")}>
                        <Link
                          to="/about/mile-stone"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Milestones
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("aboutDrop")}>
                        <Link
                          to="/leadership"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Leadership
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <div className="backdropdown absolute left-0 right-0 bottom-0 top-[20rem] z-10 opacity-50"></div>
              <li
                onMouseEnter={() => openDropFunction("domesticDrop")}
                onMouseLeave={() => closeDropFunction("domesticDrop")}
                // onClick={() => closeDropFunction('domesticDrop')}
                className="nav cursor-pointer"
              >
                <Link to="/domestic" className="py-[0.3rem] px-0 block">
                  Domestic
                  <i className="fa-solid fa-angle-down pl-2"></i>
                </Link>
                <div id="domesticDrop" className="absolute dropdown grid col-2">
                  <div
                    className="absolute w-10 h-6 bg-white top-[0.5rem] left-10"
                    style={{ clipPath: "polygon(50% 0%, 0px 85%, 100% 85%)" }}
                  ></div>
                  <div className="w-[17rem] h-12 absolute"></div>
                  <div className="flex">
                    <div className=" flex-col flex flex-1 py-3 shadow-md bg-white text-[#373737] text-xs w-[2.9rem] rounded-b-sm mt-1 relative z-10 top-[1.05rem]">
                      <ul className="">
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/overnight"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            Overnight Express
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/samedaydelivery"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            Same Day Delivery
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/2nddaydelivery"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            2nd Day Delivery
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/timechoicedelivery"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            Time Choice Delivery
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/redbox"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            RedBox
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/economyexpress"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            Economy Express
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/expressflyer"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            Express Flyer
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/mehfoozexpress"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            Mehfooz Express
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/liquidshipping"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            Liquid Shipments
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/studentexpress"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            Students Express
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/attestationservices"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            Attestation Services
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/ticketingservices"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            Ticketing Services
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className=" flex-col flex flex-1 py-3 shadow-md bg-white text-[#373737] text-xs w-[17.9rem] rounded-b-sm mt-1 relative z-10 top-[1.05rem]">
                      <ul className="">
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/codandcodplus"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            COD & COD+
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/paymentsolution"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            Payment Solutions
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/shipmentinsurance"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            Shipment Insurance (CVI)
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/tcsfresh"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            TCS Fresh
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/ecomsolution"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            E-com Solutions
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/mms"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            MMS
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/overlandexpress"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            Overland Express
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/Warehousing"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            Warehousing
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/distribution"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            Distribution
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/pack-n-go"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            PackNGo
                          </Link>
                        </li>
                        <li onClick={() => closeDropFunction("domesticDrop")}>
                          <Link
                            to="/domestic/coldchain"
                            className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                          >
                            Cold Chain Management
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </li>

              <div className="backdropdown absolute left-0 right-0 bottom-0 top-[20rem] z-10 opacity-50"></div>
              <li
                onMouseEnter={() => openDropFunction("internationalDrop")}
                onMouseLeave={() => closeDropFunction("internationalDrop")}
                // onClick={() => closeDropFunction('internationalDrop')}
                className="nav cursor-pointer"
              >
                <Link to="/international" className="py-[0.3rem] px-0 block">
                  {" "}
                  International
                  <i className="fa-solid fa-angle-down pl-2"></i>
                </Link>

                <div id="internationalDrop" className="absolute dropdown">
                  <div
                    className="absolute w-10 h-6 bg-white top-[0.5rem] left-10"
                    style={{ clipPath: "polygon(50% 0%, 0px 85%, 100% 85%)" }}
                  ></div>
                  <div className="w-[17rem] h-12 absolute"></div>
                  <div className="py-3 shadow-md bg-white text-[#373737] text-xs w-[9.9rem] rounded-b-sm mt-1 relative z-10 top-[1.05rem]">
                    <ul className="">
                      <li
                        onClick={() => closeDropFunction("internationalDrop")}
                      >
                        <Link
                          to="/international/redbox"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          RedBox
                        </Link>
                      </li>
                      <li
                        onClick={() => closeDropFunction("internationalDrop")}
                      >
                        <Link
                          to="/international/expressflyer"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Express Flyer
                        </Link>
                      </li>
                      <li
                        onClick={() => closeDropFunction("internationalDrop")}
                      >
                        <Link
                          to="/international/uspasswordrenewal"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          US Passport Renewal
                        </Link>
                      </li>
                      <li
                        onClick={() => closeDropFunction("internationalDrop")}
                      >
                        <Link
                          to="/international/studentexpress"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Students Express
                        </Link>
                      </li>
                      <li
                        onClick={() => closeDropFunction("internationalDrop")}
                      >
                        <Link
                          to="/international/visatronix"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Visatronix
                        </Link>
                      </li>
                      <li
                        onClick={() => closeDropFunction("internationalDrop")}
                      >
                        <Link
                          to="/international/internationalfreight"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          International Freight
                        </Link>
                      </li>
                      <li
                        onClick={() => closeDropFunction("internationalDrop")}
                      >
                        <Link
                          to="/international/custombrokrage"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Customs Brokerage
                        </Link>
                      </li>
                      <li
                        onClick={() => closeDropFunction("internationalDrop")}
                      >
                        <Link
                          to="/international/regional-trucking"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Regional Trade / TIR
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <div className="backdropdown absolute left-0 right-0 bottom-0 top-[20rem] z-10 opacity-50"></div>
              <li
                onMouseEnter={() => openDropFunction("expressDrop")}
                onMouseLeave={() => closeDropFunction("expressDrop")}
                // onClick={() => closeDropFunction('expressDrop')}
                className="nav cursor-pointer"
              >
                <Link to="/tcsexpress" className="py-[0.3rem] px-0 block">
                  {" "}
                  Express
                  <i className="fa-solid fa-angle-down pl-2"></i>
                </Link>
                <div id="expressDrop" className="absolute dropdown">
                  <div
                    className="absolute w-10 h-6 bg-white top-[0.5rem] left-10"
                    style={{ clipPath: "polygon(50% 0%, 0px 85%, 100% 85%)" }}
                  ></div>
                  <div className="w-[17rem] h-12 absolute"></div>
                  <div className="py-3 shadow-md bg-white text-[#373737] text-xs w-[9.9rem] rounded-b-sm mt-1 relative z-10 top-[1.05rem]">
                    <ul className="">
                      <li onClick={() => closeDropFunction("expressDrop")}>
                        <Link
                          to="/domestic-express"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Domestic Express
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("expressDrop")}>
                        <Link
                          to="/international-express"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          International Express
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("expressDrop")}>
                        <Link
                          to="/aviation"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Aviation
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("expressDrop")}>
                        <Link
                          to="/financial-services"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Financial Services
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("expressDrop")}>
                        <Link
                          to="/ecom-solution"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          E-com Solutions
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("expressDrop")}>
                        <Link
                          to="/intiana-travel"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Travel & Tours
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("expressDrop")}>
                        <Link
                          to="/visatronix"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Visatronix
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("expressDrop")}>
                        <Link
                          to="/mms"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          MMS
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <div className="backdropdown absolute left-0 right-0 bottom-0 top-[20rem] z-10 opacity-50"></div>
              <li
                onMouseEnter={() => openDropFunction("logisticsDrop")}
                onMouseLeave={() => closeDropFunction("logisticsDrop")}
                // onClick={() => closeDropFunction('logisticsDrop')}
                className="nav cursor-pointer"
              >
                <Link to="/tcslogistics" className="py-[0.3rem] px-0 block">
                  Logistics
                  <i className="fa-solid fa-angle-down pl-2"></i>
                </Link>
                <div id="logisticsDrop" className="absolute dropdown">
                  <div
                    className="absolute w-10 h-6 bg-white top-[0.5rem] left-10"
                    style={{ clipPath: "polygon(50% 0%, 0px 85%, 100% 85%)" }}
                  ></div>
                  <div className="w-[17rem] h-12 absolute"></div>
                  <div className="py-3 shadow-md bg-white text-[#373737] text-xs w-[9.9rem] rounded-b-sm mt-1 relative z-10 top-[1.05rem]">
                    <ul className="">
                      <li onClick={() => closeDropFunction("logisticsDrop")}>
                        <Link
                          to="/overland-logistics"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Overland Express
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("logisticsDrop")}>
                        <Link
                          to="/fleet-transportation"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Fleet & Transportation
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("logisticsDrop")}>
                        <Link
                          to="/warehousing"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Warehousing
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("logisticsDrop")}>
                        <Link
                          to="/distribution"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Distribution
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("logisticsDrop")}>
                        <Link
                          to="/international-freights"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          International Freight
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("logisticsDrop")}>
                        <Link
                          to="/customs-bokerage"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Customs Brokerage
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("logisticsDrop")}>
                        <Link
                          to="/pack-n-go"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          PackNGo
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("logisticsDrop")}>
                        <Link
                          to="/expo-logistics"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Expo Logistics
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("logisticsDrop")}>
                        <Link
                          to="/project-logistics"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Project Logistics
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("logisticsDrop")}>
                        <Link
                          to="/coldchain"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Cold Chain Management
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("logisticsDrop")}>
                        <Link
                          to="/agri-logistics"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Agri Logistics
                        </Link>
                      </li>
                      <li onClick={() => closeDropFunction("logisticsDrop")}>
                        <Link
                          to="/regional-trade"
                          className="py-[0.3rem] px-3 hover:bg-[#e1e1e1] block"
                        >
                          Regional Trade / TIR
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li className="cursor-pointer relative nav ">
                <Link to="/ecom-solution">
                  <div className="flex items-center">E-com Solutions</div>
                </Link>
              </li>
              <li className="cursor-pointer relative nav ">
                <Link to="/customer-services">
                  <div className="flex items-center">Contact Us</div>
                </Link>
              </li>

              <li>
                <Link to="/customer-portals">
                  <button className="bg-[#CC1219] lg:w-[8rem] h-7 rounded-sm cursor-pointer transition-all duration-500 gradientbg">
                    My TCS
                  </button>
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};
export default HeaderResponsiveComponent;
